export default "__VITE_ASSET__aefe40f7__"